export enum MembershipLevelsEnum {
  MDRT = "MDRT",
  COT = "Court of the Table",
  TOT = "Top of the Table",
};

export default {}